module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-image"
  }, [_c('div', {
    staticClass: "page-image-title"
  }, [_vm._v("定宽定高")]), _vm._v(" "), _c('mt-image', {
    attrs: {
      "src": "http://res.wisedu.com/fe_components/images/errorTip/no_search_result2.png",
      "width": "200px",
      "height": "200px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-image-title"
  }, [_vm._v("图片100%自适应")]), _vm._v(" "), _c('mt-image', {
    attrs: {
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb0ce350","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/image.vue
// module id = 539
// module chunks = 0